import {
  ONE_MONTH, THREE_MONTH, ONE_YEAR, FIVE_YEAR, ALL,
} from '../topic_classes/ChartFilters';

export const defaultChartGraphData = {
  type: 'scatter',
  mode: 'lines+markers',
  line: {
    color: '#3971c1',
    width: 1.5,
    shape: 'linear',
  },
  marker: {
    size: 6,
  },
  fill: 'tozeroy',
  fillcolor: 'rgba(57, 113, 193, 0.26)',
  cliponaxis: false,
  hoverinfo: 'none',
  x: [],
  y: [],
  showlegend: false,
};

export const defaultChartGraphLastPointData = {
  type: 'scatter',
  mode: 'lines',
  line: {
    color: '#3971c1',
    width: 1,
    dash: '3px',
  },
  cliponaxis: false,
  hoverinfo: 'none',
  x: [],
  y: [],
  showlegend: false,
};

export const hoverChartMarkerData = {
  x: [],
  y: [],
  type: 'scatter',
  mode: 'markers',
  marker: {
    color: '#292929',
    size: 9,
  },
  showlegend: false,
  hoverinfo: 'skip',
};

export const defaultChartLayoutData = {
  autosize: true,
  dragmode: false,
  xaxis: {
    fixedrange: true,
    type: 'date',
    tickfont: {
      size: 12,
      family: 'Lato',
    },
    mirror: 'ticks',
    linecolor: '#e0e0e0',
    linewidth: 1,
    zeroline: false,
    tickformat: '%b<br />%Y',
    cliponaxis: false,
  },
  yaxis: {
    fixedrange: true,
    showgrid: false,
    tickfont: {
      size: 12,
      family: 'Lato',
    },
    side: 'right',
    mirror: 'ticks',
    linecolor: '#e0e0e0',
    linewidth: 1,
    zeroline: false,
    cliponaxis: false,
  },
};

export const capitalStructureChartFilter = [
  FIVE_YEAR, ALL,
];

export const ukInsightsChartFilter = [
  ONE_MONTH, THREE_MONTH, ONE_YEAR, FIVE_YEAR, ALL,
];
